<template>
  <v-container fluid>
        <v-card>
          <v-toolbar dense flat >
            <v-btn v-show="mode === 'page'" @click="$router.go(-1)" icon light>
              <v-icon>chevron_left</v-icon>
            </v-btn>
            <v-toolbar-title>{{fagency.name.caption}}
            </v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
        <v-card-scroll v-show="fagency && fagency.nza" md flat :offset="calcOffset(60, 104)">
          <v-layout row wrap>
            <v-flex>
          <v-card>
            <v-card-text>
              <v-layout row>
               <!-- <v-component :is="renderCompanyFlags()" /> -->
              <v-layout justify-end row wrap>
              <v-chip
                v-for="tag in tags"
                :key = tag.id
                small
                disabled
                text-color="secondary"
                @click="editNotesDialogOpen()"
                >
                <span class="text-xs-center">
                {{tag.name}}
                </span>
              </v-chip>
              </v-layout>
              </v-layout>

              <component :is="createNameComp(fagency)"/>
              <component :is="createNameShortComp(fagency)"/>
              <div v-show="fagency.accrStartDate">Дата аккредитации: <b>{{formatDate(fagency.accrStartDate)}}</b>
              </div>
              <div v-show="fagency.accrFinalDate">Дата прекращения действия аккредитации: <b>{{formatDate(fagency.accrFinalDate)}}</b>
              </div>
              <div v-show="fagency.prolongationDate">Дата начала осуществления деятельности : <b>{{fagency.accrStartDate ? formatDate(fagency.accrStartDate) : '-'}}</b>
              </div>
              <div v-show="fagency.prolongationDate">Дата решения о продлении срока действия аккредитации: <b>{{formatDate(fagency.prolongationDate)}}</b>
              </div>
              <!-- <span v-html="formatStatus(company.status)"></span> -->
              <div>
                НЗА <b v-html="fagency.nza"></b>
                <v-component :is="renderCopyButton('Копировать нза', getCompanyNza)" />
                ИНН <b v-html="renderInnHtml(fagency.inn)"></b>
                <v-component :is="renderCopyButton('Копировать инн', getCompanyInn)" />
                КПП <b>{{fagency.kpp}}</b>
                <v-component :is="renderCopyButton('Копировать кпп', getCompanyKpp)" />
              </div>
              <div>
              Вид обособленного подразделения: <b> {{ fagency.kind === 'BRANCH' ? 'Филиал иностранного юридического лица' : 'Представительство иностранного юридического лица'}}</b>
              </div>
              <div>
              Основной вид деятельности: <b><span v-html="renderFirstActivityHtml(fagency.activities)"></span></b>
              </div>
              <div>Численность иностранных сотрудников: <b>{{fagency.staffNumber && fagency.staffNumber.value !== null? fagency.staffNumber.value : 'нет данных' }}</b></div>

              <!-- <div v-html="formatTaxMode(fagency.taxMode)"></div> -->
              <component :is="createAddressComp(fagency)"/>
              <component :is="createHeadsComp(fagency.heads)"/>
              <component :is="createForeignOrgComp(fagency)"/>

              <div v-show="notesAvailable"><br/>
                <a @click="editNotesDialogOpen()">{{notes ? 'Примечания:' : 'Внесите корпоративные заметки (они будут видны Вашим коллегам).'}}</a>
                <div style="white-space: pre-wrap; overflow-wrap: break-word;" v-html="notes"></div>
              </div>
              <div v-show="notesAvailable">
                <v-layout justify-begin row wrap>
                <v-chip
                  small
                  disabled
                  text-color="secondary"
                  @click="goDepo()"
                  >
                  <v-tooltip bottom open-delay="500">
                    <span slot="activator">
                     <v-icon>storage</v-icon>
                    </span>
                    <span>Перейти в депозитарий</span>
                  </v-tooltip></span>
                </v-chip>
                </v-layout>
              </div>
              <div v-show="notesAvailable"><br/>
                <a @click="editNotesDialogOpen()">{{privateNotes ? 'Личные заметки:' : 'Внесите личные заметки (они будут видны только Вам).'}}</a>
                <span style="white-space: pre-wrap; overflow-wrap: break-word;" v-html="privateNotes"></span>
              </div>

          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex sm6>
        <v-card>
          <v-card-text>
        Организация проводившая аккредитацию:
        <component :is="createTaxOfficeComp(fagency.accrTaxOffice)"/>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex xs12 sm6>
        <v-credentinals-panel fill-height v-if="fagency.taxCredential" :tax="fagency.taxCredential"></v-credentinals-panel>
      </v-flex>
      <v-flex sm6>
          <v-client-preview-panel fill-height v-if="fagency && fagency.reference && fagency.reference.inn" :inn="parseInt(fagency.reference.inn)" :clientId="fagency.clientId"></v-client-preview-panel>
        </v-flex>
        <v-flex sm6>
          <v-visit-panel fill-height v-if="fagency && fagency.reference && fagency.reference.ref && getProfileHaveClient" :topCount="5" :refCode="fagency.reference.ref"></v-visit-panel>
        </v-flex>
      </v-layout>
      </v-card-scroll>
          <v-card-actions>
            <v-layout row wrap>
<!--               <v-flex py-1 v-show="company && company.inn && !company.clientId && !this.accountNameShort">
                <v-component :is="createButton('Приглашение', 'mail_outline', 'Пригласить в Систему АТЛАНТ-СМАРТ', invite)" />
              </v-flex>
 -->
              <v-flex py-1 v-if="fagency && fagency.reference">
                <v-component :is="createButton('Ссылка', 'content_copy', 'Копировать ссылку в буфер обмена', copyLink)" />
              </v-flex>
              <v-flex py-1 v-if="fagency && fagency.reference && getProfileHaveClient && !favoriteLists && !this.accountNameShort">
                <v-component :is="createButton('Контрагент', 'add_circle_outline', 'Добавить контрагента в Мои контрагенты', addFavorite)" />
              </v-flex>
              <v-flex py-1 v-if="fagency && fagency.reference && getProfileHaveClient && favoriteLists && !this.accountNameShort">
                <v-component :is="createButton('Атрибуты', 'info_outline', 'Атрибуты котрагента в Моих контрагентах', editNotesDialogOpen)" />
              </v-flex>
            </v-layout>
          </v-card-actions>
    </v-card>
  </v-container>
</template>

<script>
  import { mapGetters } from 'vuex'
  import server from '../../api/server'
  import formats from '../../api/formats'
  import dialogs from '../common/dialogs'
  import people from '../people/index.js'
  import vCardScroll from '../common/CardScroll'
  import vNotesForm from './NotesForm'
  import vVisitPanel from './VisitPanel'
  import vClientPreviewPanel from './ClientPreviewPanel'
  import vCredentinalsPanel from '../info/CredentinalsPanel'

  export default {
    name: 'foreign-agency-page',
    components: {vCardScroll, vVisitPanel, vClientPreviewPanel, vCredentinalsPanel},
    data: () => ({
      showAllCompanies: false,
      fagency: null,
      clientCompanyId: null,
      banks: [],
      favoriteLists: null,
      privateNotes: null,
      notes: null,
      tags: null,
      accountNameShort: null,
      otherAttribs: []
    }),
    props: {
      itemId: {
        type: String,
        default: null
      },
      fullscreen: {
        type: Boolean,
        default: false
      },
      mode: {
        type: String,
        default: 'page'
      },
      notesAvailable: {
        type: Boolean,
        default: true
      },
      notesEditable: {
        type: Boolean,
        default: true
      }
    },
    created () {
      this.initFAgency()
    },
    mounted () {
      if (this.itemId) {
        this.fetchFAgencyProps(this.itemId)
      }
    },
    watch: {
      itemId: function (newVal, oldVal) { // watch it
        if (newVal) {
          this.fetchFAgencyProps(newVal)
        } else {

        }
      },
      getProfileHaveClient: function (newVal, oldVal) { // watch it
        this.refreshCompanyProps()
      }
    },
    computed: {
      ...mapGetters({
        getProfileHaveClient: 'getProfileHaveClient',
        getClientUrl: 'getClientUrl',
        getRefToUrl: 'getRefToUrl',
        renderEmployeeReference: 'renderEmployeeReference',
        renderReference: 'renderReference',
        renderInnHtml: 'renderInnHtml',
        renderInnflHtml: 'renderInnflHtml',
        renderDateSince: 'renderDateSince',
        renderStatus: 'renderStatus',
        renderFlags: 'renderFlags',
        renderFirstActivityHtml: 'renderFirstActivityHtml',
        renderUnreliableHtml: 'renderUnreliableHtml',
        getIconName: 'getIconName',
        getEmailHeaderReport: 'getEmailHeaderReport',
        getAgreementHeader1Report: 'getAgreementHeader1Report',
        getAgreementHeader2Report: 'getAgreementHeader2Report',
        getAgreementFooterReport: 'getAgreementFooterReport',
        getClientEnvelopeReport: 'getClientEnvelopeReport',
        renderCopyButton: 'renderCopyButton',
        renderContactButton: 'renderContactButton',
        calcDialogOfs: 'calcDialogOfs',
        calcOfs: 'calcOfs'
      })
    },
    methods: {
      calcOffset (off, offModal) {
        return this.calcOfs(off, offModal)
      },
      formatDate (dateTime) {
        return formats.blank(dateTime, formats.formatDate)
      },
      createNameComp (fagency) {
        var self = this
        var template = ''.concat(
          `<div>
            <div>
              <b><span v-html="getDto()"></span></b>
              {{self.renderDateSince(dto)}}
               <v-component :is="self.renderCopyButton('Копировать название', self.getCompanyNameFull)" />
            </div>
            <div>
             <span v-html="self.renderUnreliableHtml(dto)"></span>
            </div>
           </div>`
        )
        return {
          template: template,
          data: function () {
            return {
              self: self,
              fagency: fagency,
              dto: fagency.name,
              formats: formats
            }
          },
          methods: {
            getDto () {
              return this.dto && this.dto.value ? this.dto.value : formats.formatWarningHtml('ЕГРЮЛ не содержит запись о названии компании')
            }
          }
        }
      },
      createNameShortComp (fagency) {
        var self = this
        var template = ''.concat(
          `<div>
            <div>
              Сокращенное название: <b><span v-html="getDto()"></span></b>
               <v-component :is="self.renderCopyButton('Копировать название', self.getCompanyNameShort)" />
            </div>
           </div>`
        )
        return {
          template: template,
          data: function () {
            return {
              self: self,
              fagency: fagency,
              dto: fagency.name.nameShort,
              formats: formats
            }
          },
          methods: {
            getDto () {
              return this.dto ? this.dto : '-'
            }
          }
        }
      },
      createForeignOrgComp (company) {
        var self = this
        var template = ''.concat(
          `<div>
            <div>
              Головная компания: <div><b><span v-html="getDto()"></span></b>
              <v-component :is="self.renderCopyButton('Копировать название компании', self.getForeignName)" /></div>
              <div v-show="dto">{{dto && dto.countryName ? dto.countryName : '-'}} </div>
            </div>
           </div>`
        )
        return {
          template: template,
          data: function () {
            return {
              self: self,
              dto: company.foreignOrg
            }
          },
          methods: {
            getDto () {
              if (!this.dto) {
                return '-'
              }
              return `${this.dto.name ? this.dto.name : (this.dto.nameShort ? this.dto.nameShort : '-')}`
            }
          }
        }
      },
      createTaxOfficeComp (taxOffice) {
        var self = this
        var template = ''.concat(
          `<div>
            <div>
              <b><span v-html="getDto()"></span></b>
              <div v-if="dto && dto.code">Код подразделения: <b>{{dto.code}}</b></div>
              <div v-if="dto && dto.address">Адрес: <b>{{dto.address}}</b></div>
           </div>
           </div>`
        )
        return {
          template: template,
          data: function () {
            return {
              self: self,
              dto: taxOffice
            }
          },
          methods: {
            getDto () {
              if (!this.dto) {
                return '-'
              }
              return `${this.dto.name ? this.dto.name : '-'}`
            }
          }
        }
      },
      createAddressComp (company) {
        var self = this
        var template = ''.concat(
          `<div>
            <div>
              Адрес: <b><span v-html="getDto()"></span></b>
              {{self.renderDateSince(dto)}}
              <v-component :is="self.renderCopyButton('Копировать адрес', self.getCompanyAddress)" />
            </div>
           </div>`
        )
        return {
          template: template,
          data: function () {
            return {
              self: self,
              company: company,
              dto: company.address,
              formats: formats
            }
          },
          methods: {
            getDto () {
              return this.dto && this.dto.value ? this.dto.value : formats.formatWarningHtml('ЕГРЮЛ не содержит запись об адресе компании')
            }
          }
        }
      },
      createHeadsComp (heads) {
        var self = this
        var template = `
        <div>
          <b v-if="!heads || heads.length === 0">${formats.formatWarningHtml('ЕГРЮЛ не содержит запись о руководителе компании')}</b>
          <template v-for="head in heads">
            <v-component :is="self.createEmployeeComp(head)"/>
          </template>
        </div>
        `
        return {
          template: template,
          data: function () {
            return {
              self: self,
              heads: heads
            }
          }
        }
      },
      createEmployeeComp (employee) {
        var self = this
        var template = `
        <div>
        <div>
          {{employee.position}}
          <v-component :is="self.renderCopyButton('Копировать должность', getPosition)" /> :
        </div>
        <span v-html="self.renderEmployeeReference(employee)"></span>
        <v-component :is="self.renderCopyButton('Копировать ФИО', getNameFull)" />` +
        `
        <v-component :is="self.renderContactButton('Открыть контакт физического лица', openContact)" />
        ` +
        `
          <div>
            ИНН ${self.renderInnflHtml(employee.inn)}
            <v-component :is="self.renderCopyButton('Копировать ИНН', getInn)" />
          </div>
        </div>
        `
        return {
          template: template,
          data: function () {
            return {
              self: self,
              employee: employee
            }
          },
          methods: {
            getPosition () {
              return self.getCompanyEmployeePosition(employee)
            },
            getNameFull () {
              return self.getCompanyEmployeeNameFull(employee)
            },
            getInn () {
              return self.getCompanyEmployeeInn(employee)
            },
            openContact () {
              let refCode = formats.getValue(self.fagency, ['reference', 'ref'])
              people.openByHuman(refCode, employee)
            }
          }
        }
      },
      createCopyButton (caption, icon, hint, action) {
        var template = ''.concat(
          `<div><v-tooltip bottom open-delay="500">
            <div slot="activator">
              <v-btn  small flat  @click="self.copyToClipboard(action)">
                <v-icon small>{{icon}}</v-icon>{{caption}}
              </v-btn>
            </div>
            <span>{{hint}}</span>
          </v-tooltip></div>`
        )
        var self = this
        return {
          template: template,
          data: function () {
            return {
              caption: caption,
              icon: icon,
              hint: hint,
              action: action,
              self: self
            }
          }
        }
      },
      getCompanyNameFull () {
        return `${formats.getValue(this.fagency, ['name', 'value'])}`
      },
      getCompanyNameShort () {
        return `${formats.getValue(this.fagency, ['name', 'nameShort'])}`
      },
      getCompanyNza () {
        return `${formats.getValue(this.fagency, ['nza'])}`
      },
      getCompanyInn () {
        return `${formats.formatInn(formats.getValue(this.fagency, ['inn']))}`
      },
      getCompanyKpp () {
        return `${formats.getValue(this.fagency, ['kpp'])}`
      },
      getCompanyAddress () {
        return `${formats.getValue(this.fagency, ['address', 'value'])}`
      },
      getForeignName () {
        return `${formats.getValue(this.fagency, ['foreignOrg', 'name'])}`
      },
      getCompanyEmployeePosition (employee) {
        console.log('getCompanyEmployeePosition', employee)
        return `${formats.getValue(employee, ['position'])}`
      },
      getCompanyEmployeeNameFull (employee) {
        return `${formats.getValue(employee, ['nameFull'])}`
      },
      getCompanyEmployeeInn (employee) {
        return `${formats.formatInnfl(formats.getValue(employee, ['inn']))}`
      },
      getFAgencyProps (id, cb) {
        const cbError = (e) => {
          this.$store.commit('setErrorStatus', {error: e, context: 'Ошибка сервера при получении информации о представительстве иностранной компании из ЕГРЮЛ '})
        }
        server.openApiGet(
          '/openapi/foreign-agencies/' + id,
          cb,
          cbError)
      },
      fetchFAgencyProps (id) {
        this.initFAgency()
        this.getFAgencyProps(id, (data) => {
          this.fagency = data
          this.fetchFavoriteProps(id)
        })
      },
      initFAgency () {
        this.fagency = {
          id: null,
          inn: null,
          nameShort: '',
          name: ''
        }
      },
      fetchFavoriteProps (inn) {
        this.$store.dispatch('getFavoriteRefs', 'nza:' + inn).then((data) => {
          if (!Array.isArray(data) || data.length < 1) {
            console.log('fetchFAgencyProps', data)
            return
          }
          if (this.getProfileHaveClient) {
            this.clientCompanyId = data[0].clientCompanyId
            this.banks = data[0].banks
            this.favoriteLists = data[0].tags
            this.privateNotes = data[0].privateNotes
            this.notes = data[0].notes
            this.tags = data[0].tags
            this.monitoring = data[0].monitoring
            this.accountNameShort = data[0].accountNameShort
            this.otherAttribs = data.slice(1)
          } else {
            this.clientCompanyId = null
            this.banks = []
            this.favoriteLists = null
            this.privateNotes = null
            this.notes = null
            this.tags = null
            this.monitoring = false
            this.accountNameShort = null
            this.otherAttribs = []
          }
        })
      },
      refreshCompanyProps () {
        if (this.itemId) {
          this.fetchFAgencyProps(this.itemId)
        }
      },
      copyLink () {
        let refCode = formats.getValue(this.fagency, ['reference', 'ref'])
        this.$store.dispatch('copyCompanyLink', this.getClientUrl(refCode))
      },
      addFavorite () {
        let refCode = formats.getValue(this.fagency, ['reference', 'ref'])
        if (refCode) {
          this.$store.dispatch('addFavoriteCompany', {refCode: refCode, tags: this.tags ? this.tags.map(t => t.id) : null})
          this.refreshCompanyProps()
        }
      },
      editNotesDialogOpen: function (item) {
        if (!this.notesEditable) {
          return
        }
        var self = this
        const setNotes = function (data) {
          self.refreshCompanyProps()
        }
        dialogs.register('v-notes-form', vNotesForm)
        var comp = { template: `
          <v-notes-form v-on:input="setNotes" v-on:close="$emit('close')" :fullscreen="fullscreen" :model="model"></v-notes-form>
        `,
          data () {
            return {
              model: {clientCompanyId: self.clientCompanyId, banks: self.banks, company: self.fagency, privateNotes: self.privateNotes, notes: self.notes, tags: self.tags, monitoring: self.monitoring},
              setNotes: setNotes,
              fullscreen: self.$vuetify.breakpoint.xsOnly
            }
          }
        }
        dialogs.modal(comp)
      },
      goDepo: function () {
        let tag = `#${formats.getValue(this.fagency, ['reference', 'ref'])}`
        this.$router.push({path: '/doc_list/root', query: {tag: [tag]}})
      },
      createButton (caption, icon, hint, action) {
        var template = ''.concat(
          `<v-tooltip top open-delay="500">
              <div slot="activator">
                <v-btn flat  @click="action">
                  <v-icon left>{{icon}}</v-icon>{{caption}}
                </v-btn>
              </div>
              <span>{{hint}}</span>
            </v-tooltip>`
        )
        return {
          template: template,
          data: function () {
            return {
              caption: caption,
              icon: icon,
              hint: hint,
              action: action
            }
          }
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// ForeignAgencyPage.vue?0966feaa